export { default } from "./featured-news";
